<template>
  <SideBarLinkItem
    v-if="vueProps.sidebarLink.childLinks?.length === 0"
    :sidebar-link="vueProps.sidebarLink"
    :nest-level="1"
  />
  <v-list-group 
    v-else
  >
    <template v-slot:activator="{ props }">
      <v-list-item 
        v-bind="props"
        :prepend-icon="vueProps.sidebarLink.icon"
        :title="vueProps.sidebarLink.name"
      ></v-list-item>
    </template>
    <SideBarLinkItem
      v-for="childLink in vueProps.sidebarLink.childLinks"
      :key="childLink.name"
      :sidebar-link="childLink"
      :nest-level="1"
    />
  </v-list-group>
</template>
<script setup lang="ts">
import SideBarLinkItem from '@/layout/components/sidebar/SideBarLinkItem.vue';
import { defineProps } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';

const vueProps = defineProps<{
  sidebarLink: SidebarLink;
}>();
</script>
